import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routerActions } from './routes';


@NgModule({
  imports: [RouterModule.forRoot(routerActions.getRoutes(), { anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
